module.exports = __webpack_public_path__ + "static/media/_nagorno-karabakh.213a6b35.png";